import type { PartialWidgetContext } from '@/types/cms'
import Partials from '@/elements/Partials'
import styles from './GridContent.module.scss'
import AppContext from '@/types/context'

export interface GroupGridProps {
  children: Array<PartialWidgetContext>
}

const GridContent = ({ item, context }: { item: GroupGridProps; context: AppContext }) => {
  return (
    <div className={styles.content}>
      {item.children.map((widget: PartialWidgetContext, index) => {
        return <Partials key={index} context={context} item={widget as any} />
      })}
    </div>
  )
}

export default GridContent
